var script_loaded=!1;function loadJSscripts(){setTimeout(function(){if(!script_loaded){script_loaded=!0;var t=document.getElementsByTagName("script");for(i=0;i<t.length;i++)null!==t[i].getAttribute("data-src")&&(t[i].setAttribute("src",t[i].getAttribute("data-src")),delete t[i].dataset.src);var e=document.getElementsByTagName("link");for(i=0;i<e.length;i++)null!==e[i].getAttribute("data-href")&&(e[i].setAttribute("href",e[i].getAttribute("data-href")),delete e[i].dataset.href);setTimeout(function(){document.dispatchEvent(new CustomEvent("StartAsyncLoading")),document.dispatchEvent(new CustomEvent("StartKernelLoading"))},400)}},9e3)}function loadJSscriptsNow(){if(!script_loaded){console.log("now ..."),script_loaded=!0;var t=document.getElementsByTagName("script");for(i=0;i<t.length;i++)null!==t[i].getAttribute("data-src")&&(t[i].setAttribute("src",t[i].getAttribute("data-src")),delete t[i].dataset.src);var e=document.getElementsByTagName("link");for(i=0;i<e.length;i++)null!==e[i].getAttribute("data-href")&&(e[i].setAttribute("href",e[i].getAttribute("data-href")),delete e[i].dataset.href);setTimeout(function(){document.dispatchEvent(new CustomEvent("StartAsyncLoading")),document.dispatchEvent(new CustomEvent("StartKernelLoading"))},400)}}var activityEvents=["mousedown","mousemove","keydown","scroll","touchstart","click","keypress","touchmove"];activityEvents.forEach(function(t){window.addEventListener(t,loadJSscriptsNow,!1)}),document.addEventListener("load",loadJSscripts,!1),document.addEventListener("onload",loadJSscripts,!1),null!=window.addEventListener?window.addEventListener("load",loadJSscripts,!1):null!=window.attachEvent?window.attachEvent("onload",loadJSscripts):window.onload=loadJSscripts;
(function(){
    function isMobile(){
        return (window.innerWidth || document.documentElement.clientWidth) <= 767;
    }
    function isInViewport(el){
        if(!el) return false;
        var r = el.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var vw = window.innerWidth || document.documentElement.clientWidth;
        return r.top >= 0 && r.left >= 0 && r.bottom <= vh && r.right <= vw;
    }
    function initStickyATC(){
        var sticky = document.getElementById('MobileStickyATC');
        if(!sticky) return;
        var mainATC = document.querySelector('.product-single__form [data-add-to-cart]');
        var priceEl = document.querySelector('[data-product-price]');
        var variantSelect = document.querySelector('select[data-product-select]');
        var stickyPrice = sticky.querySelector('.mobile-sticky-atc__price');
        var stickyBtn = sticky.querySelector('[data-sticky-add-to-cart]');

        function syncState(){
            if(!isMobile()){ sticky.classList.remove('is-visible'); return; }
            if(!mainATC){ sticky.classList.remove('is-visible'); return; }
            if(mainATC.hasAttribute('disabled')){ stickyBtn.setAttribute('disabled','disabled'); } else { stickyBtn.removeAttribute('disabled'); }
            var atcTextSpan = mainATC.querySelector('[data-add-to-cart-text]');
            if(atcTextSpan && stickyBtn){ stickyBtn.querySelector('span').textContent = atcTextSpan.textContent.trim(); }
            if(priceEl && stickyPrice){ stickyPrice.textContent = priceEl.textContent.trim(); }
            if(isInViewport(mainATC)){ sticky.classList.remove('is-visible'); } else { sticky.classList.add('is-visible'); }
        }

        function onVariantChange(){ 
            syncState(); }

        if(stickyBtn && mainATC){
            stickyBtn.addEventListener('click', function(e){
                e.preventDefault();
                if(mainATC && !mainATC.disabled){ mainATC.click(); }
            });
        }
        if(variantSelect){ variantSelect.addEventListener('change', onVariantChange); }

        if(priceEl){
            var mo = new MutationObserver(syncState);
            mo.observe(priceEl, { childList: true, characterData: true, subtree: true });
        }
        if(mainATC){
            var mo2 = new MutationObserver(syncState);
            mo2.observe(mainATC, { attributes: true, attributeFilter: ['disabled'] });
            var textSpan = mainATC.querySelector('[data-add-to-cart-text]');
            if(textSpan){
                var mo3 = new MutationObserver(syncState);
                mo3.observe(textSpan, { childList: true, characterData: true, subtree: true });
            }
        }

        window.addEventListener('scroll', syncState, { passive: true });
        window.addEventListener('resize', syncState);
        syncState();
    }

    if(document.readyState === 'loading'){
        document.addEventListener('DOMContentLoaded', initStickyATC);
    } else {
        initStickyATC();
    }
})();



